import React, { useContext } from 'react';
import { IVideosContext, VideosContext } from '../../../videosState/videosContext';
import Text from 'components/Text/Text';
import { Checkbox } from 'antd';
import style from './UnassignedVideosCheckBox.module.scss';

const UnassignedVideosCheckBox: React.FC = () => {
	const { toggleUnassignedVideos, isUnassignedVideos } = useContext<IVideosContext>(VideosContext);

	return (
		<Checkbox
			className={style.container}
			onChange={toggleUnassignedVideos}
			checked={isUnassignedVideos}
			data-test="UnassignedVideosCheckBox">
			<Text translationNameSpace="listing" translationKey="unassignedVideosLabel" asFragment={true} />
		</Checkbox>
	);
};

export default UnassignedVideosCheckBox;
